import { Box, Chip, Grid, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SidebarLinks } from "../../config/SidebarLinks";
import { AuthRepository } from "../repositories/AuthRepository";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/system";

export default function HomePage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const taskCounts = useSelector((state) => state.taskCount);
  const [items, setItems] = useState(SidebarLinks);
  const visibleItems = items.filter((item) =>
    AuthRepository.hasAnyRole(item.roles),
  );

  return (
    <Container sx={{ pl: { xs: 0, md: "100px" } }}>
      <Grid container spacing={2} sx={{ mt: 3 }}>
        {visibleItems
          .filter((item) => item.title !== "Почетна")
          .map((item, index) => (
            <Grid
              item
              xs={12}
              md={4}
              key={index}
              onClick={() => {
                navigate(item.path);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  m: 1,
                  pt: 2,
                  pb: 2,
                  pl: 3,
                  pr: 3,
                  cursor: "pointer",
                  backgroundColor: theme.palette.background.paper,
                  boxShadow: theme.shadows[3],
                  borderRadius: "8px",
                  height: "85px",
                }}
              >
                <Typography
                  component="div"
                  variant="h5"
                  sx={{ fontWeight: "500", textAlign: "left" }}
                >
                  {item.title}
                </Typography>

                <Box
                  sx={{
                    width: 70,
                    height: 70,
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, rgb(4, 85, 152), rgb(0, 112, 204))",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {React.cloneElement(item.icon, { size: 28, color: "#fff" })}
                </Box>

                {item?.taskCountProperty &&
                taskCounts &&
                taskCounts[item.taskCountProperty] > 0 ? (
                  <div
                    style={{
                      background: "#e43521",
                      color: "white",
                      borderRadius: "50%",
                      width: 26,
                      height: 26,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {taskCounts[item.taskCountProperty]}
                  </div>
                ) : null}
              </Box>
            </Grid>
          ))}
      </Grid>
    </Container>
  );
}
